import { createRouter, createWebHistory } from "vue-router";

import CheatSheet from "../views/CheatSheet";
// import Login from "../views/Login";
import Home from "../views/Home";
import Callback from "../views/Callback";
import User from "../views/User";
import { routeGuard } from "../auth";

const routes = [
  {
    path: "/CTA",
    name: "CheatSheet",
    component: CheatSheet,
  },
  // {
  //   path: "/Login",
  //   name: "Login",
  //   component: Login,
  // },
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/callback",
    name: "Callback",
    component: Callback,
  },
  {
    path: "/user",
    name: "User",
    component: User,
    beforeEnter: routeGuard
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
